// extracted by mini-css-extract-plugin
export default {"footerBottom":"Footer_footerBottom__SA6TJ","iconContainer":"Footer_iconContainer__6oHZ3","icon":"Footer_icon__m+93W","col":"Footer_col__NfvXj"};